// Property Factory
export const TransactionFactory = (data) => {
    return {
        transactionId: data.Transaction_ID || data.transactionId ,
        transactionType: data.transaction_type || data.transactionType || "",
        transactionReference: data.transaction_reference || data.transactionReference || "",
        description: data.transaction_description || data.description || "",
        saleType: data.freehold_leasehold || data.saleType || "",
        salePrice: data.price || data.salePrice || "",
        headsOfTermDate: data.heads_term_date || data.headsOfTermDate || "",
        anticipatedCompletionDate: data.date_of_completion ||  data.anticipatedCompletionDate || "",
        ratePerAnnum: data.rate_per_annum || data.ratePerAnnum || "",
        term: data.term || data.term || "",
        purchasePrice: data.price || data.purchasePrice || "",
        status: data.status || data.transactionStatus || "Not Validated",
         currency: data.currency || "GBP",
        duration: data.duration || data.duration || "",
    };
  };

 